import { lazy } from 'react'

export const ResetForm = lazy(() => import('src/pages/landing-pages/reset'))
export const SearchMobile = lazy(() => import('../../pages/search-mobile'))
export const TermsComponent = lazy(() => import('../../pages/policies'))
export const TermsDetailsComponent = lazy(
  () => import('../../pages/policies/details')
)
export const TermsDetailsAppComponent = lazy(
  () => import('../../pages/policies-app/details')
)
export const PropertyDetailComponent = lazy(
  () => import('../../pages/property-detail')
)
export const PayComponent = lazy(() => import('../../pages/pay'))
export const PayUpdateComponent = lazy(() => import('../../pages/pay-update'))
export const ReservationsDetails = lazy(
  () =>
    import('../../pages/profile-v2/pages/my-reservations/reservation-details')
)
export const SubscriptionComponent = lazy(
  () => import('../../pages/landing-pages/subscription')
)
export const Error404Component = lazy(() => import('../../pages/404'))
export const HousiSalesComponent = lazy(
  () => import('../../pages/landing-pages/housi-sales')
)
export const Decor = lazy(() => import('../../pages/landing-pages/decor-v2'))
export const Data = lazy(() => import('../../pages/landing-pages/data'))
export const HomeV2 = lazy(() => import('../../pages/home-v2'))
